import { CognitoUserPool, CognitoUserSession } from 'amazon-cognito-identity-js';

let userPool: CognitoUserPool;

export function getUserPool(): CognitoUserPool {
  if (userPool) {
    return userPool;
  }

  const UserPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
  const ClientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
  if (!UserPoolId || !ClientId) {
    throw Error('Missing cognito UserPoolId or ClientId');
  }

  userPool = new CognitoUserPool({
    UserPoolId,
    ClientId,
  });
  return userPool;
}

export async function getTokens(): Promise<{
  accessToken?: string;
  idToken?: string;
}> {
  return new Promise((resolve, reject) => {
    const user = getUserPool().getCurrentUser();

    if (user === null) {
      return resolve({});
    }

    user.getSession((error: Error | null, session: CognitoUserSession | null) => {
      if (error) {
        return reject(error);
      }

      if (session) {
        return resolve({
          idToken: session.getIdToken().getJwtToken(),
          accessToken: session.getAccessToken().getJwtToken(),
        });
      }
      reject('getToken - impossible state');
    });
  });
}
